import React from 'react';
import { FormItem } from '..';
import PropTypes from 'prop-types';
import { InputGroup } from 'react-bootstrap';

const validations = ['maxLength'];
class SimpleText extends FormItem {
  static propTypes = FormItem.extendPropTypes({
    placeholder: PropTypes.string,
    maxLength:   PropTypes.number,
    type:        PropTypes.oneOf(['text', 'tel', 'number', 'password', 'email', 'url']),
    className:   PropTypes.string
  });
  constructor (props) {
    super(props);
    const self = this;
    self.defineValidations(validations);
  }
  getMaxLength () {
    const self = this;
    return self.maxLength || self.props.maxLength;
  }
  renderReadonly () {
    const self = this;
    return <p className="mb-0">{self.getVal() || ''}</p>;
  }
  renderInput () {
    const self = this;
    const label = self.getItemLabel();
    const { placeholder, maxLength, type } = self.props;
    const classes = self.props.className ? self.props.className.split(' ') : [];
    classes.push(self.getFormControlClassName());
    return (
      <div>
        <InputGroup>
          <input
            type={type || 'text'}
            className={classes ? classes.join(' ') : ''}
            value={self.getVal() || ''}
            placeholder={placeholder || label}
            maxLength={maxLength}
            onChange={(event) => self.setVal(event.target.value)}
          />
        </InputGroup>
        {self.renderValError()}
      </div>
    );
  }
}
export default SimpleText;
